import { useState } from "react";

import FilterIcon from "@mui/icons-material/FilterAltRounded";
import { Button } from "@mui/material";

import { ClientsSearchDialog } from "@/common/components/clients-search/components/clients-search-dialog/ClientsSearchDialog";
import { useClientsSearchContext } from "@/common/contexts/clients-search-context/ClientsSearchContext";
import { useTranslation } from "@/translations";

export function ClientsSearch() {
  const { t } = useTranslation();

  const [showClientsSearchDialog, setShowClientsSearchDialog] = useState<boolean>(false);
  const { filters, handleFiltersUpdate } = useClientsSearchContext();

  return (
    <>
      <Button
        variant="contained"
        startIcon={<FilterIcon sx={{ color: "primary.contrastText" }} />}
        onClick={() => setShowClientsSearchDialog(true)}
      >
        {t("clients.searchClients")}
      </Button>
      {showClientsSearchDialog && (
        <ClientsSearchDialog
          initialFilters={filters}
          onClose={() => setShowClientsSearchDialog(false)}
          onSearch={handleFiltersUpdate}
        />
      )}
    </>
  );
}
